export default __webpack_public_path__ + "static/media/edit.icon.a935cd7c.svg";